import { AlbumsQueryParams } from '@adminServices';
import { AlbumResponse, CreateAlbumDto, UpdateAlbumDto } from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_ALBUMS_ID = '[Albums admin]';

export const loadAlbums = createAction(
  ADMIN_ALBUMS_ID + ' Load Albums',
  props<{ params?: AlbumsQueryParams }>(),
);

export const loadAlbumsSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Load Albums Success',
  props<{ response: PaginatedResponse<AlbumResponse> }>(),
);

export const loadAlbumsFailure = createAction(
  ADMIN_ALBUMS_ID + ' Load Albums Failure',
  props<{ error: string }>(),
);

export const loadAlbum = createAction(
  ADMIN_ALBUMS_ID + ' Load Album',
  props<{ id: string }>(),
);

export const loadAlbumSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Load Album Success',
  props<{ album: AlbumResponse }>(),
);

export const loadAlbumFailure = createAction(
  ADMIN_ALBUMS_ID + ' Load Album Failure',
  props<{ error: string }>(),
);

export const createAlbum = createAction(
  ADMIN_ALBUMS_ID + ' Create Album',
  props<{ albumData: CreateAlbumDto }>(),
);

export const createAlbumSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Create Album Success',
  props<{ album: AlbumResponse }>(),
);

export const createAlbumFailure = createAction(
  ADMIN_ALBUMS_ID + ' Create Album Failure',
  props<{ error: string }>(),
);

export const updateAlbum = createAction(
  ADMIN_ALBUMS_ID + ' Update Album',
  props<{ id: string; albumData: UpdateAlbumDto }>(),
);

export const updateAlbumSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Update Album Success',
  props<{ album: AlbumResponse }>(),
);

export const updateAlbumFailure = createAction(
  ADMIN_ALBUMS_ID + ' Update Album Failure',
  props<{ error: string }>(),
);

export const deleteAlbum = createAction(
  ADMIN_ALBUMS_ID + ' Delete Album',
  props<{ id: string }>(),
);

export const deleteAlbumSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Delete Album Success',
  props<{ id: string }>(),
);

export const deleteAlbumFailure = createAction(
  ADMIN_ALBUMS_ID + ' Delete Album Failure',
  props<{ error: string }>(),
);

export const uploadPhotos = createAction(
  ADMIN_ALBUMS_ID + ' Upload Photos',
  props<{ id: string; files: File[] }>(),
);

export const uploadPhotoSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Upload Photo Success',
  props<{ album: AlbumResponse }>(),
);

export const uploadPhotosComplete = createAction(
  ADMIN_ALBUMS_ID + ' Upload Photos Complete',
  props<{ album: AlbumResponse }>(),
);

export const uploadPhotosFailure = createAction(
  ADMIN_ALBUMS_ID + ' Upload Photos Failure',
  props<{ error: string }>(),
);

export const deletePhoto = createAction(
  ADMIN_ALBUMS_ID + ' Delete Photo',
  props<{ id: string; photoId: string }>(),
);

export const deletePhotoSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Delete Photo Success',
  props<{ album: AlbumResponse }>(),
);

export const deletePhotoFailure = createAction(
  ADMIN_ALBUMS_ID + ' Delete Photo Failure',
  props<{ error: string }>(),
);

export const setTitlePhoto = createAction(
  ADMIN_ALBUMS_ID + ' Set Title Photo',
  props<{ id: string; photoId: string }>(),
);

export const setTitlePhotoSuccess = createAction(
  ADMIN_ALBUMS_ID + ' Set Title Photo Success',
  props<{ album: AlbumResponse }>(),
);

export const setTitlePhotoFailure = createAction(
  ADMIN_ALBUMS_ID + ' Set Title Photo Failure',
  props<{ error: string }>(),
);
